import React from 'react';
import { motion } from 'framer-motion';

interface LoadingSkeletonProps {
  width: string;
  height: string;
  className?: string;
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ width, height, className = '' }) => {
  const animation = {
    x: ['-100%', '200%'],
    transition: {
      x: {
        repeat: Infinity,
        repeatType: 'loop' as const,
        duration: 2,
        ease: 'linear',
      },
    },
  };

  const borderRadius = className.includes('rounded-full') ? '50%' : '4px';

  return (
    <div
      className={`skeleton-box ${className}`}
      style={{
        width,
        height,
        backgroundColor: '#e5e5e5',
        borderRadius,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <motion.div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%)',
        }}
        animate={animation}
      />
    </div>
  );
};

export default LoadingSkeleton;
